// import logo from "./logo.svg";
import "./App2.css";
import LandingPage from "./LandingPage";
import GoogleTranslateBoot from "../GoogleTranslate";

function App2() {

  return (
    <div className="FreePage">
    <div className="App">
      <GoogleTranslateBoot />
      <LandingPage />
    </div>
    </div>
  );
}

export default App2;
